/**
 * available file types
 */
export enum FileType {
  Document,
  Image,
  Design,
}
